import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'reference_other_national_intl_req_declarations_goals_guiding'

export const dataPointDefinition = {
  retracedId: 'reference_other_national_intl_req_declarations_goals_guiding',
  name: 'Reference to other national or international requirements/declarations/goals/guiding principles etc.',
  description:
    'The intent of this option selection is to understand if the facility makes reference to, or "calls out", other national or international requirements/declarations/goals/guiding principles etc. within policies/procedures. ',
  meta: {
    slcpMeta: {
      key: 'ms-1--1-3x',
      number: 'MS-PLA-3-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-1--1-3x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 32070,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
